import { render, staticRenderFns } from "./TicketBlockMembershipPrice.vue?vue&type=template&id=752777a6"
import script from "./TicketBlockMembershipPrice.vue?vue&type=script&lang=js"
export * from "./TicketBlockMembershipPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports